import { render, staticRenderFns } from "./Buisness.vue?vue&type=template&id=dcb62144&"
import script from "./Buisness.vue?vue&type=script&lang=js&"
export * from "./Buisness.vue?vue&type=script&lang=js&"
import style0 from "./Buisness.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports